import React from 'react';

import logo from './logo.png'

import './App.css';

const SocialLink = ({ href, iconClass, children }) => (
  <a 
    className="SocialLink mx2 flex justify-center align-center" 
    href={href}
    target="_blank"
    rel="noopener noreferrer"
  >
    <i className={iconClass} />
    <span className="ml1">{children}</span>
  </a>
)

function App() {
  return (
    <div className="App fullbleed flex flex-column align-center">
      <div className="App-content mx-auto text-center">
        <img src={logo} className="App-logo" alt="Website logo" />
        <h2 className="mt0 all-caps flex flex-wrap align-center justify-center">Photography <i className="fas fa-circle mx2" style={{ fontSize: '8px' }} /> Videography</h2>
        <div class="SocialLinks mx-auto flex flex-column justify-center">
          <SocialLink iconClass="fas fa-envelope" href="mailto:info@rachaelsilvester.com">info@rachaelsilvester.com</SocialLink>
          <div className="mt1 flex flex-wrap justify-center mx-auto">
            <SocialLink iconClass="fab fa-instagram" href="https://instagram.com/rachsilvester">Instagram</SocialLink>
            <SocialLink iconClass="fab fa-vimeo" href="https://vimeo.com/rachaelsilvester">Videos</SocialLink>
            <SocialLink iconClass="fab fa-flickr" href="https://www.flickr.com/photos/153174844@N08/albums">Photography</SocialLink>
          </div>
        </div>
      </div>
      <div className="Banner" />
    </div>
  );
}

export default App;
